module.exports = __webpack_public_path__ + "img/CloseButton.f1e5405c.svg";